export const addHeaderBlocksToState = (state, { type, data }) => {
  if (type !== 'ADD_HEADER_BLOCKS_TO_STATE') {
    return state;
  }

  const newState = {
    ...state,
    ...data,
  };

  // console.log(
  //   'header blocks have been added to state :',
  //   newState.header,
  //   newState.standardHeader,
  //   newState.graphicHeader,
  //   newState.standardHeaderLogo,
  //   newState.graphicHeaderBackground,
  //   newState.graphicHeaderLogo
  // );

  return newState;
};
